export default "__VITE_ASSET__CHzMP83k__"